module.exports = __webpack_public_path__ + "static/media/arranging_files.937e193a.svg";